import React, { useEffect, useState} from "react";
import {Link, useNavigate, useParams } from "react-router-dom";
import { Layout, Typography, Button, Table, Tag, Badge, Spin, Empty, Space, message, Card, Divider, Modal, Radio, Select, Pagination } from "antd";
import '../styles.css'
import api from "../api";
import adminApi from "../../admin/api";
import { monthInitials, utilities } from "../../../utilities/utlities";
import EditableText from "../../../components/editableText";
import {rfqConfig} from '../../../configurations/rfq'
import { useNavigator } from "../../../utilities/navigation";
import { pdfjs, Document, Page } from 'react-pdf';
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/legacy/build/pdf.worker.min.js`;

const ViewRFQ =(props)=> {
    const [loading, setLoading] = useState(false)
    const [rfq, setRfq] = useState(null)
    const [authorized, setAuthorized] = useState(true)
    const [canEdit, setCanEdit] = useState(false)
    const [accepted, setAccepted] = useState([])
    const [declined, setDeclined] = useState([])
    const [updating, setUpdating] = useState(false)
    const [updateKey, setUpdateKey] = useState('')
    const [showPublishModal, setShowPublishModal] = useState(false)
    const [publishRFQSelection, setPublishRFQSelection] = useState(-1)
    const [selectOptions, setSelectOptions] = useState([])
    const [invitees, setInvitees] = useState([])
    const [pdfPages, setPdfPages] = useState(null)
    const [currentPDFPageNumber, setPageNumber] = useState(1)
    const [pdfData, setPdfData] = useState(null)
    const { id } = useParams();
    const [user] = useState(utilities.loggedUser())
    const [viewPDF, setViewPDF] = useState(false)
    const sendRFIMutation = api.useSendRFI()
    const [navigator] = useNavigator();
    const { Option } = Select
    useEffect(()=>{
        if(user){
            if(user.type === 'admin'){
                setCanEdit(true)
            }
            setLoading(true)
            api.getRfq((error,data)=>{
                setLoading(false)
                if(data){
                    setRfqData(data)
                    if(data.addedBy.toString() === user._id.toString()){
                        setCanEdit(true)
                    }
                    api.getPDF(data._id,user.jwtToken,(data)=>{
                        setPdfData(data)
                    })
                }else{
                    message.error('Something went wrong, Please try again',1)
                }
            },user.jwtToken,user.type === 'admin',id,true)
            // adminApi.getProfiles((error,data)=>{
            //     if(data){
            //         const options = []
            //         for(var i=0;i<data.length;i++){
            //             options.push(<Option key={data[i].owner.email}>{data[i].companyName}</Option>)
            //         }
            //         setSelectOptions(options)
            //     }
            // },'distributor',loggedUser.jwtToken,'approved')
        }else{
            setAuthorized(false)
        }
    },[])
    const setRfqData = (data) => {
        let currentDate = new Date()
        let date = new Date(data.closingDate)
        if(date < currentDate){
            data.statusStr = 'Closed'
            data.status = 'closed'
        }else{
            let remaningTime = date - currentDate
            let deadLine = utilities.getDaysHoursFromMiliseconds(remaningTime)
            let deadlineStr = ""
            if(deadLine.days > 0){
                deadlineStr += (deadLine.days+'d') + " " + (deadLine.hours+'h') + " " +  (deadLine.minutes+'m')+ " " +(deadLine.sec+'s')
            }else{
                if(deadLine.hours > 0){
                    deadlineStr += deadLine.hours+'h' + " " +  (deadLine.minutes+'m')+ " " +(deadLine.sec+'s')
                }else{
                    deadlineStr += (deadLine.minutes+'m') + " " +(deadLine.sec+'s')
                }
            }
            data.deadLine = deadlineStr
        }
        if(data.status == 'published'){
            data.statusStr = 'Active'
        }else if(data.status == 'draft' || !data.status){
            data.status = 'draft'
            data.statusStr = 'Draft'
        }else if(data.status == 'cancelled'){
            data.statusStr = 'Cancelled'
        }
        let accepted = data.invitees.filter(x=>x.status === '2').length
        let rejected = data.invitees.filter(x=>x.status === '3').length
        setAccepted(accepted)
        setDeclined(rejected)
        if(data.medDetails){ // creating seperate array for tech in each medDetails element because inner heirarchy was difficult to handle in dynamic config
            for(let i=0;i<data.medDetails.length;i++){
                data[('medDetails'+i)] = data.medDetails[i].tech
                rfqConfig.fields.push({
                    type: 'table',
                    key: 'medDetails'+i,
                    title: 'Documents Required: '+(data.medicinesRequired[i].name + " " +data.medicinesRequired[i].strength),
                    columns: [{
                        title: 'Description',
                        key: 'description',
                        dataIndex: 'description',
                        editable: true
                    },{
                        title: 'Target Value',
                        key: 'targetValue',
                        dataIndex: 'targetValue',
                        editable: true 
                    },{
                        title: 'Acceptable Value',
                        key: 'acceptableValue',
                        dataIndex: 'acceptableValue',
                        editable: true 
                    },{
                        title: 'ResponseValue',
                        key: 'responseValue',
                        dataIndex: 'responseValue',
                        editable: true 
                    }]
                })
            }
        }
        let tableFields = rfqConfig.fields.filter(x=>x.type === 'table')
        for(let i=0;i<tableFields.length;i++){
            for(let j=0;j<data[tableFields[i].key].length;j++){
                for(let k=0;k<tableFields[i].columns.length;k++){
                    let obj = tableFields[i].columns[k]
                    obj.render = (item,objItem,index) =>{
                        return(
                            <EditableText
                                updating = {updating}
                                textKey={"text"+obj.key} 
                                editButtonKey={"ed"+obj.key}
                                cancelButtonKey={"can"+obj.key}
                                saveButtonKey={"save"+obj.key}
                                inputKey={"inpu"+obj.key}
                                width = {'100%'}
                                fontSize={15} 
                                edit = {obj.editable} 
                                value = {item}
                                save = {(value,shouldUpdate)=>{updateRFQ(tableFields[i].key,value,shouldUpdate,obj.type,index,obj.key,data)}}
                            />
                        )
                    }
                }
            }
        }
        setRfq(data)
    }
    const updateRFQ = (key,value,shouldUpdate,type,index = -1,arrayKey = null,rfq = null) => {
        if(!shouldUpdate){
            return
        }
        let data = {}
        if(type == 'date'){
            let dateSplit = value.split('-')
            value = dateSplit[2]+ "-" + monthInitials[parseInt(dateSplit[1]) - 1].toLocaleUpperCase() + "-" + dateSplit[0]
        }
        if(index < 0){
            data[key] = value
        }else{
            let obj = rfq[key]
            obj[index][arrayKey] = value
            data[key] = obj
            for(var key in data){ // handling medDetails seperatly to add seperate keys into to medDetails
                if(key.indexOf('medDetails') > -1){
                    let index = parseInt(key.split('medDetails')[1])
                    data.medDetails = rfq.medDetails
                    data.medDetails[index].tech = rfq[key]
                    delete data[key]
                    key = 'medDetails'
                }
            }
            if(key == 'medDetails'){
                for(let i=0;i<data.medDetails.length;i++){
                    data.medDetails[i].foc = data.medDetails[i].foc.map(({_id,...keepAttrs}) => keepAttrs)
                    data.medDetails[i].tech = data.medDetails[i].tech.map(({_id,...keepAttrs}) => keepAttrs)
                }
            }
            for(var i=0;i<data[key].length;i++){
                delete data[key][i]._id
            }
        }
        setUpdating(true)
        setUpdateKey(key)
        let updatedRFQ = rfq
        updatedRFQ[key] = data[key]
        setRfqData(updatedRFQ)
        api.updateRFQ(rfq._id,data,user.jwtToken,(err,data)=>{
            setUpdating(false)
            setUpdateKey('')
            if(data){
                // setRfqData(data)
            }else{
                message.error('Something went wrong',2)
            }
        })
    }
    const updateRFQStatus = (status) => {
        let data = {
            status: status
        }
        if(status === 'published'){
            if(publishRFQSelection == 1){
                data.inviteAll = true
            }else{
                if(invitees.length == 0){
                    message.error('Please select atleast one')
                    return
                }else{
                    data.invitees = invitees
                }
            }
        }
        if(rfq.status === 'closed'){
            message.error('RFQ is closed',3)
        }else{
            setUpdating(true)
            api.updateRFQ(rfq._id,data,user.jwtToken,(err,data)=>{
                setUpdating(false)
                setShowPublishModal(false)
                if(data){
                    setRfqData(data)
                    message.success('RFQ status updated',3)
                }else{
                    message.error('Something went wrong',2)
                }
            })
        }
    }
    const onClickSendRFI = (supplier) => {
        let suppliers = []
        if(supplier){
            suppliers = [supplier]
        }
        sendRFIMutation.mutate({rfqId: rfq._id,suppliers: suppliers,token: user.jwtToken},{
            onSuccess(){
                navigator(`/manage-rfi/${rfq._id}`)
            }
        })
    }
    const { Content } = Layout;
    const { Text } = Typography
    return(
        <Layout className="layout">
            <Content style={{ padding: "0 12px" }}>
                <div style={{justifyContent: 'flex-start'}} className = "site-layout-content">
                    {
                        !authorized ?
                        <Text>Not authorized</Text> :
                        loading ? 
                        <Spin size='large' tip='loading'/> :
                        rfq ?<>
                        <div className="rfqView">
                            {canEdit ? <Link to="/rfq" className="link">Manage RFQ</Link> : null}
                            <Text> / {rfq.title}</Text>
                        </div>
                        <Card className={` rfqViewCard ${updating || sendRFIMutation.isLoading ? 'disabled' : ''}`}>
                            <Space style={{width: '100%'}} direction='vertical'>
                                {/* <Text style={{fontSize: 16,fontWeight: 500,color: 'rgba(0,0,0,0.85)'}}>{rfq.title}</Text> */}
                                {/* {canEdit && rfq.status === 'draft' ? <Button onClick={()=> setShowPublishModal(true)} type="primary">Publish RFQ</Button> : null}
                                {canEdit && rfq.status === 'published' ? <Button onClick={()=> updateRFQStatus('cancelled')} type='primary' danger>Cancel</Button> : null} */}
                                <div style={{display: 'flex',flexDirection: 'row',width: '100%'}}>
                                    <div style={{width: '20%',display: 'flex'}}>
                                        <Text style={{fontSize: 15,textAlign: 'right'}}>Title</Text>
                                    </div>
                                    <div style={{width: '5%'}}></div>
                                    <div style={{width: '75%',display: 'flex',justifyContent: 'flex-start'}}>
                                        <Text>{rfq.title}</Text>
                                    </div>
                                </div>
                                <div style={{display: 'flex',flexDirection: 'row',width: '100%'}}>
                                    <div style={{width: '20%',display: 'flex'}}>
                                        <Text style={{fontSize: 15,textAlign: 'right'}}>Open Date</Text>
                                    </div>
                                    <div style={{width: '5%'}}></div>
                                    <div style={{width: '75%',display: 'flex',justifyContent: 'flex-start'}}>
                                        <Text>{rfq.openDate}</Text>
                                    </div>
                                </div>
                                <div style={{display: 'flex',flexDirection: 'row',width: '100%'}}>
                                    <div style={{width: '20%',display: 'flex'}}>
                                        <Text style={{fontSize: 15,textAlign: 'right'}}>Closing Date</Text>
                                    </div>
                                    <div style={{width: '5%'}}></div>
                                    <div style={{width: '75%',display: 'flex',justifyContent: 'flex-start'}}>
                                        <Text>{rfq.closingDate}</Text>
                                    </div>
                                </div>
                            </Space>
                            {/* <Space style={{marginTop: 15}}>
                                {rfq.status == 'published' || rfq.status == 'closed' ? 
                                <Tag color={rfq.status == 'published' ? 'green' : 'default'}>
                                    <Badge status={rfq.status === 'closed' ? 'default' : 'green'}/>
                                    {rfq.statusStr}
                                </Tag> : 
                                <Badge color={rfq.status === 'draft' ? 'blue' : 'orange'} text={rfq.statusStr}/>}
                                {rfq.status !== 'closed' ? <Tag color='red'>{rfq.deadLine}</Tag> : null}
                                {canEdit && accepted > 0 ? <Tag color='blue'>Accepted {accepted}</Tag> : null}
                                {canEdit && declined > 0 ? <Tag color='blue'>Declined {declined}</Tag> : null}
                            </Space> */}
                            <Button style = {{marginTop: 10}} onClick = {()=> setViewPDF(!viewPDF)} type='primary'>View RFQ</Button>
                            <Divider/>
                            {rfq.medicinesRequired.filter(x=>x.available).length > 0 ? <Space size = {15} style = {{width: '100%'}} direction = 'vertical'>
                                <Text style = {{fontSize: 18}}> Product(s) <Text style = {{color: 'lightgreen'}}>Found</Text> in your catalogue</Text>
                                <div>
                                    <div style = {{width: '100%', display: 'flex',justifyContent: 'space-between'}}>
                                        <Text style = {{width: '28.33%'}}>GTIN</Text>
                                        <Text style = {{width: '28.33%'}}>Trade Name</Text>
                                        <Text style = {{width: '28.33%'}}>Supplier</Text>
                                        <div style = {{width: '15%'}} />
                                    </div>
                                    <Divider className='divider' style = {{margin: '5px 0 20px 0'}}/>
                                    {rfq.medicinesRequired.map((item)=>{
                                        return item.available ?(
                                            <div style = {{width: '100%',display: 'flex',justifyContent: 'space-between'}}>
                                                <Text style = {{width: '28.33%'}} type='secondary'>{item.gtin}</Text>
                                                <Text style = {{width: '28.33%'}} type='secondary'>{item.name + " " + item.strength}</Text>
                                                <Text style = {{width: '28.33%'}} type='secondary'>{item.supplier.companyName}</Text>
                                                <Button loading = {sendRFIMutation.isLoading} style = {{width: '15%'}} onClick={()=> onClickSendRFI(item.supplier.id)} type = 'primary'>Send RFI</Button>
                                            </div>
                                        ) : null
                                    })}
                                </div>
                            </Space> : null}
                            {rfq.medicinesRequired.filter(x=>!x.available).length > 0 ? <Space size = {15} style = {{width: '100%',marginTop: 20}} direction = 'vertical'>
                                <Text style = {{fontSize: 18}}> Product(s) <Text style = {{color: 'red'}}>Not Found</Text> in your catalogue</Text>
                                <div>
                                    <div style = {{width: '100%', display: 'flex',justifyContent: 'space-between'}}>
                                        <Text style = {{width: '50%'}}>GTIN</Text>
                                        <Text style = {{width: '50%'}}>Trade Name</Text>
                                    </div>
                                    <Divider className='divider' style = {{margin: '5px 0 20px 0'}}/>
                                    {rfq.medicinesRequired.map((item)=>{
                                        return !item.available ?(
                                            <div style = {{width: '100%',display: 'flex',justifyContent: 'space-between'}}>
                                                <Text style = {{width: '50%'}} type='secondary'>{item.gtin}</Text>
                                                <Text style = {{width: '50%'}} type='secondary'>{item.name + " " + item.strength}</Text>
                                            </div>
                                        ) : null
                                    })}
                                </div>
                            </Space> : null}
                            {viewPDF ? <div style={{display: 'flex',justifyContent: 'center',width: '100%'}}>
                                {pdfData ? 
                                <Space direction='vertical'>
                                    <Document
                                        file={{data: pdfData}}
                                        onLoadSuccess={({ numPages })=> setPdfPages(numPages)}
                                        onLoadError = {(error)=> console.log(error)} >
                                        <Page pageNumber={currentPDFPageNumber} />
                                    </Document>
                                    <Pagination 
                                        style={{display: 'flex',justifyContent: 'center'}} 
                                        size="small" 
                                        onChange = {(page) => setPageNumber(page)} 
                                        simple 
                                        defaultCurrent = {currentPDFPageNumber} 
                                        total = {pdfPages * 10} 
                                    />
                                </Space> : <Spin></Spin>}
                            </div> : null}
                            {/* <div>
                                {rfqConfig.fields.map((item,index)=>{
                                    return item.type !== 'table' ?(
                                        <div style={{display: 'flex',flexDirection: 'row'}}>
                                            <div style={{width: '20%',display: 'flex',justifyContent: 'flex-end'}}>
                                                <Text key={item.key} style={{fontSize: 15,textAlign: 'right'}}>{item.title}</Text>
                                            </div>
                                            <div style={{width: '5%'}}></div>
                                            <div style={{width: '75%',display: 'flex',justifyContent: 'flex-start'}}>
                                                <EditableText type={item.type} updating = {updateKey === item.key} edit = {item.editable && canEdit} save={(value,shouldUpdate)=>updateRFQ(item.key,value,shouldUpdate,item.type)} fontSize={15} value = {rfq[item.key]}/>
                                            </div>
                                        </div>
                                    ) : (
                                        <div style={{display: 'flex',flexDirection: 'column',marginTop: 30}}>
                                            <div style={{width: '100%',display: 'flex'}}>
                                                <Text key={item.key} style={{fontWeight: 'bold',fontSize: 15,textAlign: 'right'}}>{item.title}</Text>
                                            </div>
                                            <Table style={{marginTop: 20}} columns = {item.columns} dataSource={rfq[item.key]} pagination={false}></Table>
                                        </div>
                                    )
                                })}
                            </div>
                             */}
                        </Card>
                        </> :
                        <> 
                        <Empty/>
                        </>
                    }
                </div>
            </Content>
            <Modal
                centered
                title="Publish RFQ"
                visible={showPublishModal}
                onOk={()=>updateRFQStatus('published')}
                confirmLoading={updating}
                onCancel={()=> setShowPublishModal(false)}
                maskClosable = {false}
                okText="Publish"
                closable = {false}
            >
                <Space direction="vertical">
                    <Text>Please select the RFQ Recepients</Text>
                    <Radio.Group onChange={(e)=> setPublishRFQSelection(e.target.value)} value={publishRFQSelection}>
                        <Space direction='vertical'>
                            <Radio value={1}>All</Radio>
                            <Radio value={2}>Selective</Radio>
                        </Space>
                    </Radio.Group>
                    {publishRFQSelection == '2' ? <Select mode="multiple" placeholder="Please select" allowClear style={{ marginLeft: '10%',width: '100%' }} onChange={(value)=> setInvitees(value)}>{selectOptions}</Select> : null}
                </Space>
            </Modal>
        </Layout>
    )
}
export default ViewRFQ